import { h } from 'preact';
import { Switch } from '@headlessui/react';
import clsx from 'clsx';
import { useThreekit } from '../threekit-context';
import { useModal } from '../modal-context';

function FrontBackToggle() {
  const { modalName } = useModal();
  const {
    productTag,
    setBladeSide,
    bladeSide,
    getBackgroundColorFromSelectedVariant,
    backgroundColor,
    darkMode,
  } = useThreekit();
  const variantBackgroundColor = getBackgroundColorFromSelectedVariant();

  const handleToggle = () => {
    const newBladeSide = bladeSide === 'Front' ? 'Back' : 'Front';
    setBladeSide(newBladeSide);
  };

  if (productTag === 'cstm:personalization' || productTag === 'cstm:service') {
    return;
  }

  // eslint-disable-next-line consistent-return
  return (
    <div
      className={clsx(
        'fixed laptop:absolute laptop:top-[-50px] bottom-1/2 laptop:left-[20px] left-[10px] transform rotate-90 -translate-x-[27px] laptop:transform-none laptop:h-[34px]',
        modalName === 'Inspo' ? 'laptop:fixed' : 'laptop:absolute',
        {
          'hidden laptop:block': modalName === 'Compare Materials',
        },
      )}
    >
      <div
        className={clsx(
          'flex items-center justify-center gap-2 laptop:rounded-[4px] w-[83px] h-[29px] laptop:w-[133px] laptop:h-[34px] rounded-sm',
          {
            'bg-black bg-opacity-20': darkMode,
            'bg-white bg-opacity-20': !variantBackgroundColor?.hex && !darkMode,
            'text-white': variantBackgroundColor?.isDark || darkMode,
            'text-black': !(variantBackgroundColor?.isDark || darkMode),
          },
        )}
        style={{
          backgroundColor:
            backgroundColor?.presetLightMode && variantBackgroundColor?.hex,
        }}
      >
        <span className="hidden font-m-12 laptop:inline">Front</span>
        <span className="transform -rotate-90 font-m-12 laptop:hidden">F</span>
        <Switch
          onChange={handleToggle}
          className="relative inline-flex items-center h-5 rounded-full bg-bg-6 bg-opacity-40 w-[36px]"
        >
          <span
            className={clsx(
              'inline-block h-[14px] w-[14px] transform rounded-full bg-white transition',
              {
                'translate-x-[19px]': bladeSide === 'Back',
                'translate-x-[3px]': bladeSide === 'Front',
                'bg-black': !darkMode,
              },
            )}
            style={{
              backgroundColor:
                backgroundColor?.presetLightMode && variantBackgroundColor?.hex,
            }}
          />
        </Switch>
        <span className="hidden font-m-12 laptop:inline">Back</span>
        <span className="transform -rotate-90 font-m-12 laptop:hidden">B</span>
      </div>
    </div>
  );
}

export default FrontBackToggle;
